import { useStores } from '../../stores';
import { useFormik } from 'formik';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { User } from '../../domain/User';
import { useTranslation } from "react-i18next";
import * as yup from 'yup';

interface Props {
    isOpen: boolean;
    user?: User;
    onClose: () => void;
}

interface FormValues {
    password: string;
    repeatPassword: string;
}

export default observer((props: Props) => {
    const { t } = useTranslation();
    const { userStore, notificationsStore } = useStores();

    const initialValues = {
        password: '',
        repeatPassword: ''
    } as FormValues;

    const schema = yup.object().shape({
        password: yup.string().required(t("field_is_required", { name: t("password") }))
            .min(8, t("password_is_too_short", { number: 8 })),
        repeatPassword: yup.string().required(t("field_is_required", { name: t("password") }))
            .min(8, t("password_is_too_short", { number: 8 })),
    });
    const formik = useFormik({
        validationSchema: schema,
        enableReinitialize: true,
        initialValues,
        onSubmit: (values, { resetForm }) => {
            if (values.password === values.repeatPassword) {
                userStore.changePassword(values.password, () => {
                    resetForm();
                });
                props.onClose();
            } else {
                notificationsStore.add('passwords_are_different', "error")
            }
        },
    });

    const { errors, values } = formik;
    return (
        <Dialog open={props.isOpen} onClose={props.onClose}>
            <form onSubmit={formik.handleSubmit}>
                <DialogTitle>{t("change_password")}</DialogTitle>
                <DialogContent>

                    <TextField
                        margin="normal"
                        id="password"
                        label={t("password")}
                        type="password"
                        fullWidth
                        variant="standard"
                        error={!!errors.password}
                        helperText={errors.password && errors.password as string}
                        value={values.password || ''}
                        onChange={formik.handleChange}
                    />
                    <TextField
                        margin="normal"
                        id="repeatPassword"
                        label={t("repeat_password")}
                        type="password"
                        fullWidth
                        variant="standard"
                        error={!!errors.repeatPassword}
                        helperText={errors.repeatPassword && errors.repeatPassword as string}
                        value={values.repeatPassword || ''}
                        onChange={formik.handleChange}
                    />

                </DialogContent>
                <DialogActions>
                    <Button onClick={props.onClose}>{t("cancel")}</Button>
                    <Button color="primary" type="submit">{t("submit")}</Button>
                </DialogActions>
            </form>
        </Dialog>
    );
});